import { Link as RouterLink } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Card, Stack, Link, Container, Typography } from '@mui/material';
// layouts
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { LoginForm } from '../sections/authentication/login';
import { RegisterForm } from 'src/sections/authentication/register';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const SectionStyle = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 464,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: theme.spacing(2, 0, 2, 4),
  padding: theme.spacing(5),
  backgroundColor: theme.palette.primary.contrastText
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));
// ----------------------------------------------------------------------

export default function Login() {
  return (
    <RootStyle title={`Login | ${process.env.REACT_APP_PROJECTNAME}`}>
      {/* <AuthLayout /> */}

      <SectionStyle
        // className="login_logo"
        sx={{ display: { xs: 'none', md: 'flex' }, justifyContent: 'center', alignItems: 'center' }}
      >
        <img src={process.env.REACT_APP_DRAWER_LOGO} alt="login" width={'80%'} />
      </SectionStyle>

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mt: -4 }}>
            <Typography className="heading_center" variant="h4" sx={{ color: '#010f58' }}>
              Login to {process.env.REACT_APP_PROJECTNAME}
            </Typography>
            <Typography
              className="heading_center"
              sx={{ color: 'text.secondary', marginBottom: 3 }}
            >
              Enter your details below.
            </Typography>
          </Stack>

          <LoginForm />
        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
